import { keys } from "./Keys";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { useQuery } from "react-query";
import { AlarmNotificationsType, IAlarmNotificationObjectCountModel } from "../../services/alarm-data-service/Models";
import AlarmDataService from "../../services/alarm-data-service/AlarmDataService";

export type UseAlarmSetpointNotificationCountsParams = {
    type: AlarmNotificationsType,
    organizationID: number,
    contextGroupID: number,
    //queryParams: IQueryAlarmNotificationParams
    startDate: Date,
    endDate: Date
} & BaseUseQueryParameters<IAlarmNotificationObjectCountModel | undefined>;

export function useAlarmSetpointNotificationCounts({
    type,
    organizationID,    
    contextGroupID,
    //queryParams,
    startDate,
    endDate,
    enabled,    
    refreshSeconds,
    onSuccess,
    onError
}: UseAlarmSetpointNotificationCountsParams) {
    return useQuery<IAlarmNotificationObjectCountModel, RestError>(
        keys.alarmSetPointNotificationCounts(type, organizationID, contextGroupID, startDate, endDate),
        ({ signal }) => {
            return AlarmDataService.queryAlarmSetpointNotificationCounts(
                type,
                organizationID,
                contextGroupID,
                //queryParams,
                startDate,
                endDate,
                signal
            );
        },
        {
            enabled,
            onError: onError,
            onSuccess: onSuccess,
            //refetchInterval: refreshSeconds ? refreshSeconds  * 1000 : false,
            refetchInterval: false,
            refetchOnWindowFocus: false,
            staleTime: Infinity

        }
    );
}